import { parseAri } from '@atlassian/jira-platform-ari';

export const getResourceIdfromAri = (value: string) => parseAri(value)?.resourceId ?? '';
